// extracted by mini-css-extract-plugin
export var active = "_1y-b";
export var activeIndicator = "_1y-6";
export var animate = "_1y-a";
export var disabled = "_1y-c";
export var flat = "_1y-1";
export var fullWidth = "_1y-3";
export var lg = "_1y-9";
export var md = "_1y-8";
export var redoButtonTabGroup = "_1y-0";
export var sm = "_1y-7";
export var tabButton = "_1y-4";
export var tabButtonsContainer = "_1y-2";
export var xs = "_1y-5";